
import watch from 'redux-watch';
import template from 'header/search-overlay.j2';

import Config from '../configs/config.js';

import {
    CLOSE_SITE_SEARCH,
    toggleSiteSearch
} from '../actions/headerActions.js';

import { generate } from '../../../core/js/utils/componentUtils';

let config = {
    templateLocation: '.dom-search-overlay',
    watch: 'core.header.siteSearch',
    name: 'searchOverlayComponent',
    attachEvents: attachEvents,
    template: template
};

export function init(store, overrides = {}) {
    return generate(config, store, overrides);
}

/**
 * Bootstrap the component onto the page
 * @returns {undefined}
 */
export function initialize(store) {
    attachEvents(store);
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('touchend click'), '.js-search-overlay', _.debounce((e) => {
        $.event.trigger({
            type: CLOSE_SITE_SEARCH
        });
    }, 100));
}
